import { Component, Input } from '@angular/core';
import { ModalUtilsService } from 'src/app/services/modal-utils.service';

@Component({
  selector: 'bpc-last-execution-column',  
  templateUrl: './last-execution-column.component.html',
  styleUrl: './last-execution-column.component.scss'
})
export class LastExecutionColumnComponent {
  @Input() row!: any;

  constructor(
    private modalUtilsService: ModalUtilsService
  ){

  }

  removeCronJob(id: string) {
    let modalParameters = this.modalUtilsService.modalParameters;
    modalParameters.currentModalAction = "removeCronJob";
    modalParameters.selectedJobId = id;
    this.modalUtilsService.toggalModal.next(modalParameters);
  }
}
